const UserIdConstant = "{05675528-623a-4036-8872-86a5ab847837}";
const CustomerIdConstant = "{05675528-623a-4036-8872-86a5ab847837}";
const Transaction = "Transaction";
const Sod = "Sod";
const TransactionShipment = "TransactionShipment";
const TransactionAdjustment = "TransactionAdjustment";
const TransactionReceipt = "TransactionReceipt";
const History = "History";
const InventoryItems = "InventoryItems";
const CountResults = "ViewEnterCountResults";
const ViewCountAdjustments = "ViewCountAdjustments";
const InventoryLots = "InventoryLots";
const InventorySubLots = "InventorySubLots";
const Reports = "Reports";
const CustomizeSettings = "CustomizeSettings";
const UserSyncing = "UserSyncing";
const Security = "Security";
const TransactionReceiptRead = "TransactionReceiptRead";
const TransactionReceiptCreate = "TransactionReceiptCreate";
const TransactionReceiptUpdate = "TransactionReceiptUpdate";
const TransactionReceiptDelete = "TransactionReceiptDelete";
const HistoryRead = "HistoryRead";
const HistoryCreate = "HistoryCreate";
const HistoryUpdate = "HistoryUpdate";
const HistoryDelete = "HistoryDelete";
const HistoryReadReceipts = "ReadReceipts";
const HistoryReadShipments = "ReadShipments";
const HistoryReadAdjustments = "ReadAdjustments";
const InventoryItemsRead = "InventoryItemsRead";
const InventoryItemsCreate = "InventoryItemsCreate";
const InventoryItemsUpdate = "InventoryItemsUpdate";
const InventoryItemsDelete = "InventoryItemsDelete";
const ReportsRead = "ReportsRead";
const ReportsCreate = "ReportsCreate";
const ReportsUpdate = "ReportsUpdate";
const ReportsDelete = "ReportsDelete";
const CustomizeSettingsRead = "CustomizeSettingsRead";
const CustomizeSettingsCreate = "CustomizeSettingsCreate";
const CustomizeSettingsUpdate = "CustomizeSettingsUpdate";
const CustomizeSettingsDelete = "CustomizeSettingsDelete";
const UserSyncingRead = "UserSyncingRead";
const UserSyncingCreate = "UserSyncingCreate";
const UserSyncingUpdate = "UserSyncingUpdate";
const UserSyncingDelete = "UserSyncingDelete";
const SecurityRead = "Read";
const SecurityCreate = "SecurityCreate";
const SecurityUpdate = "SecurityUpdate";
const SecurityDelete = "SecurityDelete";
const UserRead = "UserRead";
const UserChange = "UserChange";
const UserCreate = "UserCreate";
const UserDelete = "UserDelete";
const RoleRead = "RoleRead";
const RoleChange = "RoleChange";
const RoleCreate = "RoleCreate";
const RoleDelete = "RoleDelete";
const TransactionsAccess = "TransactionsAccess";
const HistoryAccess = "HistoryAccess";
const InventoryItemsAccess = "InventoryItemsAccess";
const ReportsAccess = "ReportsAccess";
const CustomizeSettingsAccess = "CustomizeSettingsAccess";
const UserSyncingAccess = "UserSyncingAccess";
const SecurityAccess = "SecurityAccess";
const DataAuthPermission = "DataAuthPermission";
const TransactionShipmentRead = "TransactionShipmentRead";
const TransactionShipmentCreate = "TransactionShipmentCreate";
const TransactionShipmentUpdate = "TransactionShipmentUpdate";
const TransactionShipmentDelete = "TransactionShipmentDelete";
const TransactionReceiptCustomerTransactionCreate = "TransactionReceiptCustomerTransactionCreate";
const TransactionReceiptCustomerTransactionUpdate = "TransactionReceiptCustomerTransactionUpdate";
const TransactionShipmentCustomerTransactionCreate = "TransactionShipmentCustomerTransactionCreate";
const TransactionShipmentCustomerTransactionUpdate = "TransactionShipmentCustomerTransactionUpdate";
const TransactionAdjustmentRead = "TransactionAdjustmentRead";
const TransactionAdjustmentCreate = "TransactionAdjustmentCreate";
const TransactionAdjustmentUpdate = "TransactionAdjustmentUpdate";
const TransactionAdjustmentDelete = "TransactionAdjustmentDelete";
const SecurityUserRead = "SecurityUserRead";
const SecurityUserCreate = "SecurityUserCreate";
const SecurityUserUpdate = "SecurityUserUpdate";
const SecurityUserDelete = "SecurityUserDelete";
const SecurityRoleRead = "SecurityRoleRead";
const SecurityRoleCreate = "SecurityRoleCreate";
const SecurityRoleUpdate = "SecurityRoleUpdate";
const SecurityRoleDelete = "SecurityRoleDelete";
const SecurityRoleAddPermissions = "SecurityRoleAddPermissions";
const SecurityRoleRemovePermission = "SecurityRoleRemovePermission";
const SecurityRoleViewPermission = "SecurityRoleViewPermission";
const SecurityDeleteAssignedRole = "SecurityDeleteAssignedRole";
const SecurityUserViewAssignedRoles = "SecurityUserViewAssignedRoles";
const SecurityUserRoleAssign = "SecurityUserRoleAssign";
const SodReceiveOrders = "SodReceiveOrders";
const SodUpdateOrders = "SodUpdateOrders";
const SodReviewProdOrders = "SodReviewProdOrders";
const SodUpdateProdOrders = "SodUpdateProdOrders";
const SodDeleteProdOrders = "SodDeleteProdOrders";
const SodInsertProdOrders = "SodInsertProdOrders";
const SodReadProdOrders = "SodReadProdOrders";
const SodReadLotSelect = "SodReadLotSelect";
const SodUpdateLotSelect = "SodUpdateLotSelect";
const SodDeleteLotSelect = "SodDeleteLotSelect";
const SodReadMasterOrder = "SodReadMasterOrder";
const SodUpdateMasterOrder = "SodUpdateMasterOrder";
const SodDeleteMasterOrder = "SodDeleteMasterOrder";
const SodInsertMasterOrder = "SodInsertMasterOrder";
const SodInsertPullOrder = "SodInsertPullOrder";
const SodUpdatePullOrder = "SodUpatePullOrder";
const SodDeletePullOrder = "SodDeletePullOrder";
const SodReadPullOrder = "SodReadPullOrder";
const SodReadWetStrat = "SodReadWetStrat";
const SodUpdateWetStrat = "SodUpdateWetStrat";
const SodDeleteWetStrat = "SodDeleteWetStrat";
const SodInsertWetStrat = "SodInsertWetStrat";
const SodReadDryStrat = "SodReadDryStrat";
const SodUpdateDryStrat = "SodUpdateDryStrat";
const SodDeleteDryStrat = "SodDeleteDryStrat";
const SodInsertDryStrat = "SodInsertDryStrat";
const SodReadStratComplete = "SodReadStratComplete";
const SodUpdateStratComplete = "SodUpdateStratComplete";
const SodDeleteStratComplete = "SodDeleteStratComplete";
const SodReadShipingComplete = "SodReadShipingComplete";
const SodUpdateShipingComplete = "SodUpdateShipnigComplete";
const CalcSeedQtyEmailToAddress = "Michael.Clifford@weyerhaeuser.com";

const SodUpdateOrdersScreen = "ViewUpdateOrdersScreen";
const SodReviewRecordsScreen = "ViewReviewRecordsScreen";
const SodLotSelectScreen = "ViewLotSelectScreen";
const SodLotMasterRecordsScreen = "ViewLotMasterRecordsScreen";
const SodPullOrderScreen = "ViewPullOrderScreen";
const SodSelectDryStratScreen = "ViewSelectDryStratScreen";
const SodStratCompleteScreen = "ViewStratCompleteScreen";
const SodShipCompleteScreen = "ViewShipCompleteScreen";
const SodBareRootCalculatorScreen = "ViewBareRootCalculatorScreen";
const SodPlugsCalculatorScreen = "ViewPlugsCalculatorScreen";
const SodAddSeedLotsScreen = "ViewAddSeedLotsScreen";
const SodEditSeedInventoryScreen = "ViewEditSeedInventoryScreen";
const SodEditTablesScreen = "ViewEditTablesScreen";
const SodMasterVsAbecesReport = "ViewMasterVsAbecesReport";
const SODAbecesvsMasterReport = "ViewAbecesvsMasterReport";
const SodAbecesVsArchiveReport = "ViewAbecesVsArchiveReport";
const SodTransactionExtractReport = "ViewTransactionExtractReport";
const SodProdUnitStatusReport = "ViewProdUnitStatusReport";
const SodCutLotExtractReport = "ViewCutLotExtractReport";
const SodErrorsReport = "ViewErrorsReport";
const SodCurrentReport = "ViewCurrentReport";
const SodSalesRepExtractReport = "ViewCurrentReport";
const SodLotSelectReport = "ViewLotSelectReport";
const SodDryStratReport = "ViewDryStratReport";
const SodShipCompGreenHouseReport = "ViewShipCompGreenHouseReport";
const SodShipNurseryCompReport = "ViewShipCompNurseryReport";
const SodPullOrderReport = "ViewPullOrderReport";
const SodChargeSheetReport = "ViewChargeSheetReport";
const SodSODvsAbecasReport = "ViewSODvsAbecasReport";
const SodUserSecurityScreen = "ViewUserSecurityScreen";
const SodBagTagsReport = "ViewBagTagsReport";
const SodCutLotLabelBagTagsReport = "ViewCutLotLabelBagTagsReport";
const SodManualBagTagsReport = "ViewManualBagTagsReport";
const TransactionReceiptCreateLot = "CreateLot";
const TransactionReceiptCreateSubLot = "CreateSubLot";
const TransactionReceiptViewItemLocationInfo = "ViewItemLocationInfo";
const TransactionReceiptViewSchedulingInfo = "ViewSchedulingInfo";
const TransactionReceiptViewOnlyActiveItems =
  "TransactionReceiptViewOnlyActiveItems";
const TransactionReceiptViewItemsWithZeroQuantity =
  "TransactionReceiptViewItemsWithZeroQuantity";
const TransactionReceiptViewOnlyActiveLots =
  "TransactionReceiptViewOnlyActiveLots";
const TransactionReceiptViewOnlyShippersAttachedToCustomer =
  "TransactionReceiptViewOnlyShippersAttachedToCustomer";
const TransactionReceiptViewOnlyConsigneeAttachedToCustomers =
  "TransactionReceiptViewOnlyConsigneeAttachedToCustomers";
const HistoryScreen = "HistoryScreen";
const TMMenuViewRametCodes = "ViewRametsCodes";
const TMMenuViewLocationCodes = "ViewLocationCodes";
const TMMenuViewOrchardCodes = "ViewOrchardCodes";
const TMMenuViewBlockCodes = "ViewBlockCodes";
const TMMenuViewNewInspection = "ViewNewInspection";
const TMMenuViewImportInspections= "ViewImportInspections";
const TMMenuViewExportInspections = "ViewExportInspections";
const TMMenuViewPrintAssetTags = "ViewPrintAssetTags";
const TMMenuViewInspectionTypes = "ViewInspectionTypes";
const TMMenuViewInventoryReports = "ViewInventoryReports";
const ATMenuViewAdvancedReportTool = "ViewAdvancedReportTool";
const ATMenuViewARTConfiguration = "ViewARTConfiguration";
const DockDoorViewSelectionScreen = "ViewSelectionScreen";
const DockDoorViewStatusScreen = "ViewStatusScreen";
const OwnerShipTransferView = "ViewOwnershipTransfer";
const OwnerShipTransferViewIOT = "ViewInternalOwnershipTransfer";
const MoveSublotInventoryView = "ViewMoveSublotInventory";
const OMTransaction = "ViewTransaction";
const OMUpdateOrderStage = "UpdateOrderStage";
const OMUpdatePrice = "UpdatePrice";
const OMInventory = "ViewInventory";
const OMTransactionHistory = "ViewTransactionHistory";
const OMCreateQuoteRole = "CreateQuote";
const OMCreateOrderRole = "CreateOrder";
const OMUpdateQuoteeRole = "UpdateQuote";
const OMUpdateOrderRole = "UpdateOrder";
const OMReadQuoteRole = "ReadQuote";
const OMReadOrderRole = "ReadOrder";
const CreateDashboardRole = "CreateQuery";
const UpdateDashboardRole = "UpdateQuery";
const DeleteDashboardRole = "DeleteQuery";
const ViewXmMonitor="ViewXMMonitor";
const ReportsWMItemLotSublotOnHandReport = "WMItemLotSublotOnHandReport";
const ReportsWMLocationCapacityReport = "WMLocationCapacityReport";
const ReportsWMItemReOrderReport = "WMItemReOrderReport";
const ReportsWMItemLotInventoryByLocationReport = "WMItemLotInventoryByLocationReport";
const ReportsWMPrintSSCCSublotLabelsReport = "WMPrintSSCCSublotLabelsReport";
const ReportsWMPrintSSCCSerialNumberLabelsReport = "WMPrintSSCCSerialNumberLabelsReport";
const ReportsWMConsolidatedInvoiceCustomerReport = "WMConsolidatedInvoiceCustomerReport";
const ReportsWMPickingSlipWithLocationReport = "WMPickingSlipWithLocationReport";
const ReportsWMMonthlyTransactionReport = "WMMonthlyTransactionReport";
const ReportsWMTransactionSerialNumberReport = "WMTransactionSerialNumberReport";
const ReportsWMTransactionRecapEnhancedReport = "WMTransactionRecapEnhancedReport";
const ReportsWMChargeCodesReport = "WMChargeCodesReport";
const ReportsWMItemStatusReport = "WMItemStatusReport";
const ReportsWMEmptyLocationsReport = "WMEmptyLocationsReport";
const ReportsWMItemSerialNumberReport = "WMItemSerialNumberReport";
const ReportsWMScheduleReport = "WMScheduleReport";
const ReportsWMSubLotCodesReport = "WMSubLotCodesReport";
const ReportsTransactionRecapReport = "TransactionRecapReport";
const ReportsItemLotAvailabilityReport = "ItemLotAvailabilityReport";
const ReportsBillOfLadingReport = "BillOfLadingReport";
const ReportsCustomerInvoiceReport = "CustomerInvoiceReport";
const ReportsOpenReceiptsShipmentsReport = "OpenReceiptsShipmentsReport";
const ReportsHistoricalReceiptsShipmentsReport = "HistoricalReceiptsShipmentsReport";
const ReportsAgingReport = "AgingReport";
const ReportsSerialNumberReport = "SerialNumberReport";
const ReportsExternalUserCarrierReport = "ExternalUserCarrierReport";
const ReportsReceiptsPutAwayReport = "ReceiptsPutAwayReport"
const ReportsItemLocationAvailability = "ItemLocationAvailability"
const ManageDashboard = "ManageDashboard"
const DashboardConfiguration = "DashboardConfiguration"
const SecurityFacilities = "Facilities";
const OrderAcknowledgmentReport = "OrderAcknowledgmentReport";
const PickingSlipReport = "PickingSlipReport";
const DeliveryNotificationForChargeHoldShipmentsReport = "DeliveryNotificationForChargeHoldShipmentsReport";
const PickingSlipWithChargeHoldReport = "PickingSlipWithChargeHoldReport";
const InvoiceReport = "InvoiceReport";
const ItemAvailabilityReport = "ItemAvailabilityReport";
const SalesOrderEditReport = "SalesOrderEditReport";
const SalesOrderByItemReport = "SalesOrderByItemReport";
const PrintDeliveryNotification = "PrintDeliveryNotification";
const PrintQuote = "PrintQuote";
const PackingSlipReport = "PackingSlipReport";
const AT="AT";
const WM="WM";
const SO="SO";
const DD="DD";
const TM="TM";
const OM="OM";
const DB="DB";
const XM="XM";
const IM="IM";
/**
 * The modules Manage Settings exposes per-module settings for. Intersected with the licensed
 * modules from Identity/GetModules to build that screen's module menu. Display names: ModuleNames in
 * enum/Enum.js. (Report Groups does NOT use this - its dropdown mirrors the role-permissions
 * screen, see ReportGroups.js.)
 */
const SettingModules = [IM, OM, SO, WM];
const SalesOrderDataEntry = "SalesOrderDataEntry";
const OMCommitTransaction = "CommitTransaction";
const OMReplicateTransaction = "ReplicateTransaction";
const SalesOrderManagement = "SalesOrderManagement";
const Warehouse = "Warehouse";
const WarehouseMap = "ViewWarehouseMap";
const LocationManagement = "ViewLocationManagement";
const EnterLaborTracking = "ViewEnterLaborTracking";
const TransferLotsToDifferentItems = "ViewTransferLotsToDifferentItems";
const TransferSublotsToDifferentItems = "ViewTransferSublotsToDifferentItems";
const DashboardManagement = "DashboardManagement";
const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
// Single source of truth for the Enter Labor Tracking route paths (used by the
// list/form navigation, the routes in AppContainer, and NavigationPaths breadcrumbs).
const LaborTrackingRoutes = {
  List: "/wm/labortracking",
  Create: "/wm/labortracking-create",
  Edit: "/wm/labortracking-edit",
};
// Single source of truth for the WM Item Data Profile route paths (used by the list/form
// navigation, the routes in AppContainer, and NavigationPaths breadcrumbs).
const ItemDataProfileRoutes = {
  List: "/wm/data-profiles/item-data-profiles",
  Create: "/wm/data-profiles/add-item-data-profile",
  Edit: "/wm/data-profiles/edit-item-data-profile",
};
// Single source of truth for the WM Item Kit Data Profile route paths (Delphi WMD0103). Same
// module/folder/entities shape as ItemDataProfileRoutes above, per the React URL convention.
const ItemKitProfileRoutes = {
  List: "/wm/data-profiles/item-kit-profiles",
  Create: "/wm/data-profiles/add-item-kit-profile",
  Edit: "/wm/data-profiles/edit-item-kit-profile",
};
// WM Item Data Entry paths. Declared here because the Item Data Profile form's "Item Defaults"
// button navigates to the Edit route with ?recordType=P to open the profile's default-item record
// (Delphi uWMD0003.btnItemDefaultsClick -> uWMD0000.SetParameters).
const ItemDataEntryRoutes = {
  List: "/wm/codes/item-data-entry",
  Create: "/wm/codes/add-item",
  Edit: "/wm/codes/edit-item",
};
// IMITEM/IMITEMDP RECORDTYPE values. 'R' is a real record, 'P' the profile-defaults template.
const RECORD_TYPE = {
  REAL: "R",
  PROFILE_DEFAULTS: "P",
};
// Labor Tracking Entry Mode options (WMTRANSACTIONLABORTRACKING.ENTRYMODE flag).
// Static list — the enable/disable logic keys off the "Elapsed" description, not the code.
const LaborTrackingEntryModes = [
  { code: "A", name: "Allow To Enter Start & End Date, Times Field" },
  { code: "B", name: "Allow Only To Enter Start & End Times. Date Will Be Defaulted From Default Date Field" },
  { code: "C", name: "Allow Only To Enter Elapsed Hours & Minutes (Start & End Date Will Be Defaulted From Default Date)" },
];
const EarlyTagReport = "EarlyTagReport";
const PTRDailyUpdates = "DailyUpdates";
const PTRDailyUpdates2 = "DailyUpdates2";
const PTRConfiguration = "Configuration";
const PTROverrides = "Overrides";
const PTRAttributes = "Attributes";
const PTRRules = "Rules";
const PTRCropRollTool = "CropRollTool";
const PTRSecurity = "Security";
const ManageDataSource = "ManageDashboard";
const CreateDatasourceQuery = "CreateDatasourceQuery";
const UpdateDatasourceQuery = "UpdateDatasourceQuery";
const DeleteDatasourceQuery = "DeleteDatasourceQuery";
const SearchDatasourceQuery = "SearchDatasourceQuery";
const DataSourceConfiguration = "DataSourceConfiguration";
const DevexpressDashboardConfiguration = "DevexpressDashboardConfiguration"

const CreateDashboardQuery = "CreateDashboardQuery";
const UpdateDashboardQuery = "UpdateDashboardQuery";
const DeleteDashboardQuery = "DeleteDashboardQuery";
const SearchDashboardQuery = "SearchDashboardQuery";
const AdjustAvailableUnAvailableStatus = "ViewAdjustAvailableUnAvailableStatus";
const AllocateAvailableQuantities = "AllocateAvailableQuantities";
const WMTransactionManagement = "ViewTransactionManagement";
const WMTransactionDataEntry = "TransactionDataEntry";
const WMSchedulesManagement = "SchedulesManagement";
const GeneratePhysicalInventoryCount = "ViewGenerateCountRecords";
const WMCommitTransactions = "CommitTransactions";
const WMUpdateTransactionsStage = "UpdateTransactionsStage";
const WMMenuViewUndoInvoices = "ViewUndoInvoices";
const WMMenuViewUpdateInvoices = "ViewUpdateInvoices";
const WMMenuViewMockupV1 = "ViewMockupV1";
const WMMenuViewMockupV2 = "ViewMockupV2";
const WMMenuViewMockupV3 = "ViewMockupV3";
const WMMenuViewSearchCharges = "ViewSearchCharges";
const WMMenuViewGenerateStorageCharges = "ViewGenerateStorageCharges";
const WMMenuViewCalculateDeferredRevenue = "ViewCalculateDeferredRevenue";
const WMMenuViewUpdateFreeDaysGracePeriods = "ViewUpdateFreeDaysGracePeriods";
const WMMenuViewGenerateRepeatingMiscCharges = "ViewGenerateRepeatingMiscCharges";
const WMMenuViewTransferShipmentsToDispatch = "ViewTransferShipmentsToDispatch";
const WMMenuViewPurgeNeverUsedRecords = "ViewPurgeNeverUsedRecords";
const WMUnCommitTransactions = "UnCommitTransactions";
const WMMenuGenerateInvoices = "ViewGenerateInvoices";
const WMMenuCommitInvoices = "ViewCommitInvoices";
const OMUpdateOrderDetailLot="ViewOMUpdateOrderDetailLot";
const WMCustomer = "WMCustomer";
const WMTransNumSetup = "WMTransNum";
const OMSetup = "OM";

const WMConsignee = "WMConsignee";
const WMCarrier = "WMCarrier";
const WarehouseDataEntry="WarehouseDataEntry";
const WMItemDataEntry= "WMItemDataEntry";
const WMDescriptiveCode = "DescriptiveCode";
const WMLotDataEntry = "WMLotDataEntry";
const WMSublotDataEntry= "WMSublotDataEntry";
const WMChargeCode = "WMChargeCode";
const WMRateCode = "WMRateCode";
const WMRateScheduleCode = "WMRateScheduleCode";
const WMWeekSettings = "WMWeekSettings";
// Maps to Permissions.ARMenuCollectionCredit (GroupName "ARMenu", Name
// "ARCollectionCredit") in the authorization server. Both the /ar/collections/* routes in
// AppContainer.js and the AR sidebar link are gated on it, so grant it to the
// appropriate roles in Security setup before users can reach the screen - this is the
// first AR screen with its own permission code, so no seed data exists for it yet.
const ARCollectionCredit = "ARCollectionCredit";
const WMExceptions = "WMExceptions";
const WMItemDataProfile = "WMItemDataProfile";
const WMItemKitCode = "WMItemKitCode";
const WMEditSerialNumberRecords = "WMEditSerialNumberRecords";
const WMEvaluationExpression = "WMEvaluationExpression";
const WMDynValChargeConfig = "WMDynValChargeConfig";
const OMItemDataEntry= "ItemDataEntry";
const OMLotDataEntry= "LotDataEntry";
const OMTrips = "Trips";
const OMDescriptiveCodes= "DescriptiveCodes";
const OMSalesTaxCodes = "SalesTaxCodes";

const WMSearchTransactionPrf= "WMSearchTransactionPrf";
// WM Data Profiles -> Enter Item Kit Profiles. Must match the Display Name on
// Permissions.DataProfilesWMItemKitProfile in the authorization server.
const WMItemKitProfile = "WMItemKitProfile";

const ApplicationSettings="ApplicationSettings";
const ApiAuditLogs="ApiAuditLogs";
const ReportGroup = "ReportGroup";
const AppSettingsLocalStorageKey = "appSettings";
const ChatMessagesStoragePrefix = "chat_messages_";
const IMTransactionEntryForm = "TransactionEntryForm";
const IMEnterTransaction = "EnterTransaction";
const IMItemManagement = "ItemManagement";
const IMMenuSearchLocationCode = "EnterLocationCode";
const WMLocationDataEntry = "LocationDataEntry";
const IMLocationDataEntry = "LocationDataEntry";
// OM -> Processing -> Recalculate Kit Usage Details (legacy IMD0086). Same "View<Screen>" shape as the
// other operation screens' permissions (OMUpdateOrderDetailLot, WMMenuViewTransferShipmentsToDispatch).
// One OM-licensed permission only: the screen is presented from OM and has no IM menu entry, and
// omSidebarItemAllowed searches the OM permission lists exclusively, so an IMMenu permission could
// never surface it.
const OMRecalculateKitUsage = "ViewOMRecalculateKitUsage";
const WMCrateDataEntry = "CrateDataEntry";
const TaskQueue = "TaskQueue";

// TODO: This needs to be renamed to new naming guidelines
const LocationDataEntry = "EnterLocationCode";
const RFMessages = "RFMessages";
const OMSalesOrderProfile = "SalesOrderProfile";
const APIKey = "APIKey";
const OptionsNoYes = [{ key: "N", value: "No" },{ key: "Y", value: "Yes" }];
// Transfer-quantity option for WM Move Sublot Inventory (mirrors backend Constants.TransferQtyFlag).
const TransferQtyFlag = { All: "A", Fixed: "F", Percent: "P" };
const AllowedPageSizes = 10;

// WMS inventory-UOM (Trans Unit) codes — WMSERIALNUMBER/WMTRANSACTIONDETAIL inventoryUomFlag.
const WMSInventoryUOMFlag = {
  Inventory: "I",
  Pieces: "P",
  Packages: "K",
  Shipments: "N",
};

// Display lookup built from the codes above so the two cannot drift apart.
const WMSInventoryUOMFlags = [
  { ID: WMSInventoryUOMFlag.Inventory, Text: "Inventory Units" },
  { ID: WMSInventoryUOMFlag.Pieces, Text: "Pieces" },
  { ID: WMSInventoryUOMFlag.Packages, Text: "Packages" },
  { ID: WMSInventoryUOMFlag.Shipments, Text: "Shipments" },
];

// WM transaction type flags (WMTRANSACTIONHEADER.TransactionType). All = no type filter.
const WMTransactionType = { Receipt: "R", Shipment: "S", Adjustment: "A", Storage: "C", Miscellaneous: "M", All: "" };
// WM transaction charge type flags (WMTRANSACTIONCHARGE.ChargeType).
const WMChargeType = { Transaction: "T", Item: "I", Miscellaneous: "M", None: "N" };

// Excel Export Constants
const ExcelExportDefaultFileName = "DataGrid_Export.xlsx";
const ExcelExportDefaultSheetName = "Sheet1";
const ExcelExportDatasourceFileName = "Datasource.xlsx";
const ExcelExportDatasourceSheetName = "Datasource";
const ExcelExportDashboardFileName = "Dashboard.xlsx";
const ExcelExportDashboardSheetName = "Dashboard";
const ExcelExportDashboardConfigFileName = "Dashboard_Configuration.xlsx";
const ExcelExportDashboardConfigSheetName = "Dashboard_Configuration";
const ExcelExportDatasourceConfigFileName = "Datasource_Configuration.xlsx";
const ExcelExportDatasourceConfigSheetName = "Datasource_Configuration";
const ExcelExportXmMonitorFileName = "XM_Monitor.xlsx";
const ExcelExportXmMonitorSheetName = "XM_Monitor";
const OMTransferDeliveriesToDispatch = "TransferDeliveriesToDispatch";
const OMExportEdiDocuments = "ExportEdiDocuments";
const OMGeneratePODropShipOrders = "GeneratePODropShipOrders";
const POGenerateRequisition = "GenerateRequisition";
const AIMenuViewChat = "ViewChat";
const AIMenuViewVectorStoreDataEntry = "ViewVectorStoreDataEntry";
const AIMenuViewFileDataEntry = "ViewFileDataEntry";
const AIChatSelectVectorStoresForChat = "SelectVectorStoresForChat";
const ReportsQueryTransactionsByCustomer = "QueryTransactionsByCustomer";
// OM Reports -> Sales Orders -> Query Orders By Customer (legacy OMD0010).
const OMReportsQueryOrdersByCustomer = "QueryOrdersByCustomer";

// IDCUSTOMER.STATUS option list - coded fields render as descriptive dropdowns
// (Architecture.md rule 3). Shared so screens don't each inline the A/I values.
const CUSTOMER_STATUS_OPTIONS = [
  { id: 'A', name: 'Active' },
  { id: 'I', name: 'Inactive' },
];

// IDCUSTOMER.SOINVENTORYPRICELEVEL - price levels A..Z excluding W. Shared so
// screens don't each inline this list (Architecture.md R1).
const PRICE_LEVEL_OPTIONS = 'ABCDEFGHIJKLMNOPQRSTUVXYZ'.split('').map((code) => ({
  id: code,
  name: `Price Level - ${code}`,
}));

// IDMASTER.IDTYPE - identity type for a Customer record.
const ID_TYPE_CUSTOMER = '01';
export const ID_MEMBER_TYPE_CONTACT = '22';

// Separator for the item-code list sent to the Update Requisition Details viewer. ASCII Unit Separator (0x1F) is
// not typeable and cannot occur in an item code, unlike a comma - codes containing a comma were being split into
// fragments. Must stay in sync with Constants.RequisitionViewer.ItemCodeSeparator on the API side.
const ItemCodeSeparator = "\u001F";
const LoadPanelPosition = { of: '#accordion-containe2' };
const LoadPanelShadingColor = "rgba(0,0,0,0.4)";
export {
  OMTransferDeliveriesToDispatch,
  OMGeneratePODropShipOrders,
  OMSalesOrderProfile,
  UserIdConstant,
  CustomerIdConstant,
  Transaction,
  History,
  InventoryItems,
  CountResults,
  InventoryLots,
  InventorySubLots,
  Reports,
  CustomizeSettings,
  UserSyncing,
  Security,
  TransactionReceiptRead,
  TransactionReceiptCreate,
  TransactionReceiptUpdate,
  TransactionReceiptDelete,
  HistoryRead,
  HistoryCreate,
  HistoryUpdate,
  HistoryDelete,
  InventoryItemsRead,
  InventoryItemsCreate,
  InventoryItemsUpdate,
  InventoryItemsDelete,
  ReportsRead,
  ReportsCreate,
  ReportsUpdate,
  ReportsDelete,
  CustomizeSettingsRead,
  CustomizeSettingsCreate,
  CustomizeSettingsUpdate,
  CustomizeSettingsDelete,
  UserSyncingRead,
  UserSyncingCreate,
  UserSyncingUpdate,
  UserSyncingDelete,
  SecurityRead,
  SecurityCreate,
  SecurityUpdate,
  SecurityDelete,
  UserRead,
  UserCreate,
  UserChange,
  UserDelete,
  RoleRead,
  RoleCreate,
  RoleChange,
  RoleDelete,
  TransactionsAccess,
  HistoryAccess,
  InventoryItemsAccess,
  ReportsAccess,
  CustomizeSettingsAccess,
  UserSyncingAccess,
  SecurityAccess,
  DataAuthPermission,
  TransactionShipmentRead,
  TransactionShipmentCreate,
  TransactionShipmentUpdate,
  TransactionShipmentDelete,
  TransactionReceiptCustomerTransactionCreate,
  TransactionReceiptCustomerTransactionUpdate,
  TransactionShipmentCustomerTransactionCreate,
  TransactionShipmentCustomerTransactionUpdate,
  TransactionAdjustmentRead,
  TransactionAdjustmentCreate,
  TransactionAdjustmentUpdate,
  TransactionAdjustmentDelete,
  SecurityUserRead,
  SecurityUserCreate,
  SecurityUserUpdate,
  SecurityUserDelete,
  SecurityRoleRead,
  SecurityRoleCreate,
  SecurityRoleUpdate,
  SecurityRoleDelete,
  SecurityRoleAddPermissions,
  SecurityRoleRemovePermission,
  SecurityRoleViewPermission,
  SecurityDeleteAssignedRole,
  SecurityUserViewAssignedRoles,
  SecurityUserRoleAssign,
  TransactionReceipt,
  TransactionShipment,
  TransactionAdjustment,
  Sod,
  SodReceiveOrders,
  SodUpdateProdOrders,
  SodUpdateOrders,
  SodReviewProdOrders,
  SodDeleteProdOrders,
  SodInsertProdOrders,
  SodReadProdOrders,
  SodReadLotSelect,
  SodUpdateLotSelect,
  SodDeleteLotSelect,
  SodReadMasterOrder,
  SodUpdateMasterOrder,
  SodDeleteMasterOrder,
  SodInsertMasterOrder,
  SodReadPullOrder,
  SodUpdatePullOrder,
  SodDeletePullOrder,
  SodInsertPullOrder,
  SodReadWetStrat,
  SodUpdateWetStrat,
  SodDeleteWetStrat,
  SodInsertWetStrat,
  SodReadDryStrat,
  SodUpdateDryStrat,
  SodDeleteDryStrat,
  SodInsertDryStrat,
  SodReadStratComplete,
  SodUpdateStratComplete,
  SodDeleteStratComplete,
  SodReadShipingComplete,
  SodUpdateShipingComplete,
  CalcSeedQtyEmailToAddress,
  SodUpdateOrdersScreen,
  SodReviewRecordsScreen,
  SodLotSelectScreen,
  SodLotMasterRecordsScreen,
  SodPullOrderScreen,
  SodSelectDryStratScreen,
  SodStratCompleteScreen,
  SodShipCompleteScreen,
  SodBareRootCalculatorScreen,
  SodPlugsCalculatorScreen,
  SodAddSeedLotsScreen,
  SodEditSeedInventoryScreen,
  SodEditTablesScreen,
  SodMasterVsAbecesReport,
  SODAbecesvsMasterReport,
  SodAbecesVsArchiveReport,
  SodTransactionExtractReport,
  SodProdUnitStatusReport,
  SodCutLotExtractReport,
  SodErrorsReport,
  SodCurrentReport,
  SodSalesRepExtractReport,
  SodLotSelectReport,
  SodDryStratReport,
  SodShipCompGreenHouseReport,
  SodShipNurseryCompReport,
  SodPullOrderReport,
  SodSODvsAbecasReport,
  SodChargeSheetReport,
  SodUserSecurityScreen,
  SodBagTagsReport,
  SodCutLotLabelBagTagsReport,
  SodManualBagTagsReport,
  TransactionReceiptCreateLot,
  TransactionReceiptCreateSubLot,
  TransactionReceiptViewSchedulingInfo,
  TransactionReceiptViewOnlyActiveItems,
  TransactionReceiptViewItemLocationInfo,
  TransactionReceiptViewItemsWithZeroQuantity,
  TransactionReceiptViewOnlyActiveLots,
  TransactionReceiptViewOnlyShippersAttachedToCustomer,
  TransactionReceiptViewOnlyConsigneeAttachedToCustomers,
  HistoryReadReceipts,
  HistoryReadShipments,
  HistoryReadAdjustments,
  HistoryScreen,
  TMMenuViewLocationCodes,
  TMMenuViewRametCodes,
  TMMenuViewOrchardCodes,
  TMMenuViewBlockCodes,
  TMMenuViewNewInspection,
  TMMenuViewImportInspections,
  TMMenuViewExportInspections,
  TMMenuViewPrintAssetTags,
  TMMenuViewInspectionTypes,
  TMMenuViewInventoryReports,
  ATMenuViewAdvancedReportTool,
  ATMenuViewARTConfiguration,
  DockDoorViewSelectionScreen,
  DockDoorViewStatusScreen,
  OwnerShipTransferView,
  OwnerShipTransferViewIOT,
  MoveSublotInventoryView,
  OMTransaction,
  OMTransactionHistory,
  OMCreateQuoteRole,
  OMCreateOrderRole,
  ReportsWMItemLotSublotOnHandReport,
  ReportsWMLocationCapacityReport,
  ReportsTransactionRecapReport,
  ReportsItemLotAvailabilityReport,
  ReportsBillOfLadingReport,
  ReportsCustomerInvoiceReport,
  ReportsOpenReceiptsShipmentsReport,
  ReportsHistoricalReceiptsShipmentsReport,
  ReportsAgingReport,
  ReportsSerialNumberReport,
  ReportsExternalUserCarrierReport,
  ReportsReceiptsPutAwayReport,
  OMUpdateQuoteeRole,
  OMUpdateOrderRole,
  OMReadQuoteRole,
  OMReadOrderRole,
  ManageDashboard,
  DashboardConfiguration,
  CreateDashboardRole,
  UpdateDashboardRole,
  DeleteDashboardRole,
  SecurityFacilities,
  OMInventory,
  OrderAcknowledgmentReport,
  InvoiceReport,
  ViewXmMonitor,
  ItemAvailabilityReport,
  SalesOrderEditReport,
  PrintDeliveryNotification,
  AT,
  WM,
  SO,
  SettingModules,
  DD,
  TM,
  OM,
  DB,
  XM,
  SalesOrderDataEntry,
  OMCommitTransaction,
  Warehouse,
  WarehouseMap,
  LocationManagement,
  EnterLaborTracking,
  TransferLotsToDifferentItems,
  TransferSublotsToDifferentItems,
  EMPTY_GUID,
  LaborTrackingRoutes,
  ItemDataProfileRoutes,
  ItemKitProfileRoutes,
  ItemDataEntryRoutes,
  RECORD_TYPE,
  LaborTrackingEntryModes,
  SalesOrderManagement,
  OMUpdateOrderStage,
  DashboardManagement,
  EarlyTagReport,
  PTRDailyUpdates,
  PTRDailyUpdates2,
  PTRConfiguration,
  PTROverrides,
  PTRAttributes,
  PTRRules,
  PTRCropRollTool,
  PTRSecurity,
  ManageDataSource,
  CreateDatasourceQuery,
  UpdateDatasourceQuery ,
  DeleteDatasourceQuery,
  SearchDatasourceQuery,
  DataSourceConfiguration,
  DevexpressDashboardConfiguration,
  CreateDashboardQuery,
  UpdateDashboardQuery,
  DeleteDashboardQuery,
  SearchDashboardQuery,
  AdjustAvailableUnAvailableStatus,
  OMReplicateTransaction,
  AllocateAvailableQuantities,
  OMUpdatePrice,
  WMTransactionManagement,
  ViewCountAdjustments,
  WMTransactionDataEntry,
  GeneratePhysicalInventoryCount,
  WMCommitTransactions,
  WMUpdateTransactionsStage,
  WMMenuViewUndoInvoices,
  WMMenuViewUpdateInvoices,
  WMMenuViewMockupV1,
  WMMenuViewMockupV2,
  WMMenuViewMockupV3,
  WMMenuViewSearchCharges,
  WMMenuViewGenerateStorageCharges,
  WMMenuViewCalculateDeferredRevenue,
  WMMenuViewUpdateFreeDaysGracePeriods,
  WMMenuViewGenerateRepeatingMiscCharges,
  WMMenuViewTransferShipmentsToDispatch,
  WMMenuViewPurgeNeverUsedRecords,
  WMUnCommitTransactions,
  WMMenuGenerateInvoices,
  WMMenuCommitInvoices,
  OMUpdateOrderDetailLot,
  ApplicationSettings,
  ApiAuditLogs,
  AppSettingsLocalStorageKey,
  ChatMessagesStoragePrefix,
  IMTransactionEntryForm,
  IMEnterTransaction,
  IMItemManagement,
  WMCustomer,
  IMMenuSearchLocationCode,
  WMSearchTransactionPrf,
  WMItemKitProfile,
  IM,
  WMItemDataEntry,
  WMDescriptiveCode,
  WMLotDataEntry,
  WMSublotDataEntry,
  WMChargeCode,
  WMRateCode,
  WMRateScheduleCode,
  WMWeekSettings,
  ARCollectionCredit,
  WMExceptions,
  WMItemDataProfile,
  WMItemKitCode,
  WMEditSerialNumberRecords,
  WMEvaluationExpression,
  WMDynValChargeConfig,
  WMConsignee,
  RFMessages,
  WarehouseDataEntry,
  LocationDataEntry,
  WMCarrier,
  WMTransNumSetup,
  OMSetup,
  ReportsItemLocationAvailability,
  WMLocationDataEntry as WMMenuLocationDataEntry,
  IMLocationDataEntry,
  OMRecalculateKitUsage,
  OptionsNoYes,
  TransferQtyFlag,
  WMCrateDataEntry,
  TaskQueue,
  OMItemDataEntry,
  OMLotDataEntry,
  APIKey,
  AllowedPageSizes,
  WMSInventoryUOMFlag,
  WMSInventoryUOMFlags,
  WMTransactionType,
  WMChargeType,
  ExcelExportDefaultFileName,
  ExcelExportDefaultSheetName,
  ExcelExportDatasourceFileName,
  ExcelExportDatasourceSheetName,
  ExcelExportDashboardFileName,
  ExcelExportDashboardSheetName,
  ExcelExportDashboardConfigFileName,
  ExcelExportDashboardConfigSheetName,
  ExcelExportDatasourceConfigFileName,
  ExcelExportDatasourceConfigSheetName,
  ExcelExportXmMonitorFileName,
  ExcelExportXmMonitorSheetName,
  OMTrips,
  OMDescriptiveCodes,
  OMSalesTaxCodes,
  OMExportEdiDocuments,
  POGenerateRequisition,
  PickingSlipReport,
  AIMenuViewChat,
  PrintQuote,
  AIMenuViewVectorStoreDataEntry,
  AIMenuViewFileDataEntry,
  AIChatSelectVectorStoresForChat,
  WMSchedulesManagement,
  PackingSlipReport,
  SalesOrderByItemReport,
  PickingSlipWithChargeHoldReport,
  DeliveryNotificationForChargeHoldShipmentsReport,
  ReportsWMItemReOrderReport,
  ReportsWMItemLotInventoryByLocationReport,
  ReportsWMPrintSSCCSublotLabelsReport,
  ReportsWMPrintSSCCSerialNumberLabelsReport,
  ReportsWMMonthlyTransactionReport,
  ReportsWMPickingSlipWithLocationReport,
  ReportsWMTransactionSerialNumberReport,
  ReportsWMConsolidatedInvoiceCustomerReport,
  ReportsWMTransactionRecapEnhancedReport,
  ReportsWMChargeCodesReport,
  ReportsWMItemStatusReport,
  ReportsWMEmptyLocationsReport,
  ReportsWMItemSerialNumberReport,
  ReportsWMScheduleReport,
  ReportsWMSubLotCodesReport,
  ReportGroup,
  ReportsQueryTransactionsByCustomer,
  OMReportsQueryOrdersByCustomer,
  CUSTOMER_STATUS_OPTIONS,
  PRICE_LEVEL_OPTIONS,
  ID_TYPE_CUSTOMER,
  ItemCodeSeparator,
  LoadPanelPosition,
  LoadPanelShadingColor
};



 